export function activateToggleView() {

    const chooseShowsButton = document.querySelector('.choose-shows');

    if (!chooseShowsButton) return;
  

    chooseShowsButton.addEventListener('click', () => {

      const toggleViewElement = document.querySelector('.farlo-ui-crm__choice-CITIES');
      

 
        toggleViewElement.classList.toggle('farlo-ui-crm__choice-CITIES--active');
      
    });


  }